// import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";
// import { useParams, useNavigate } from "react-router-dom";
// import config from '../../config';

// function UpdatePortfolioDetail() {
//     const { id } = useParams(); // Get the project ID from the URL
//     const navigate = useNavigate();
//     const [portfolio, setPortfolio] = useState({
//         title: '',
//         location: ''
//     });
//     const [featuredImage, setFeaturedImage] = useState(null);
//     const [error, setError] = useState('');
//     const [successMessage, setSuccessMessage] = useState('');
//     const featuredImageRef = useRef(null);

//     useEffect(() => {
//         const fetchPortfolioDetails = async () => {
//             try {
//                 const response = await axios.get(`${config.BASE_URL}/api/admin/get-portfolio/${id}`, { withCredentials: true });
//                 setPortfolio(response?.data);
//             } catch (err) {
//                 setError('Failed to fetch portfolio details');
//             }
//         };

//         fetchPortfolioDetails();
//     }, [id]);

//     const handleRemoveImage = async (imageName) => {
//         try {
//             const response = await axios.post(`${config.BASE_URL}/api/admin/remove-image-portfolio`, {
//                 portfolioId: portfolio._id,
//                 imageName
//             }, { withCredentials: true });

//             if (response.status === 200) {
//                 // Update project state
//                 setPortfolio(prevPortfolio => {
//                     return {
//                         ...prevPortfolio,
//                         featuredImage: prevPortfolio.featuredImage === imageName ? null : prevPortfolio.featuredImage,
//                     };
//                 });
//             } else {
//                 console.error('Failed to remove image');
//             }
//         } catch (err) {
//             console.error('Error removing image:', err);
//         }
//     };

//     const handleFeaturedImageChange = (e) => {
//         setFeaturedImage(e.target.files[0]); // Set the featured image
//     };

//     const handleFormSubmit = async (e) => {
//         e.preventDefault();

//         const formData = new FormData();
//         formData.append('title', portfolio.title);
//         formData.append('location', portfolio.location);

//         if (featuredImage) {
//             formData.append('featuredImage', featuredImage);
//         }

//         try {
//             const response = await axios.put(`${config.BASE_URL}/api/admin/update-portfolio/${id}`, formData, {
//                 headers: {
//                     'Content-Type': 'multipart/form-data',
//                 },
//                 withCredentials: true,
//             });

//             setPortfolio(response.data.portfolio);

//             if (featuredImageRef.current) {
//                 featuredImageRef.current.value = '';
//             }

//             setFeaturedImage(null);
//             setSuccessMessage('Portfolio updated successfully!');
//         } catch (err) {
//             setError('Failed to update portfolio');
//         }
//     }

//     return (
//         <div className="dashboard update_detail_wrap">
//             <div className="container">
//                 <h1 className="dash_title">Edit Portfolio</h1>
//                 <div className="back_btn_wrap">
//                     <button className="back-btn" onClick={() => navigate(-1)}>Go Back</button>
//                 </div>
//                 {portfolio ? (
//                     <form onSubmit={handleFormSubmit} encType="multipart/form-data">
//                         <div className="update_details_wrap">
//                             <div className="form-group">
//                                 <label>Title</label>
//                                 <input
//                                     type="text"
//                                     value={portfolio.title}
//                                     onChange={(e) => setPortfolio({ ...portfolio, title: e.target.value })}
//                                 />
//                             </div>

//                             <div className="form-group textareaField">
//                                 <h2>Location</h2>
//                                 <textarea
//                                     name="location"
//                                     value={portfolio.location}
//                                     onChange={(e) => setPortfolio({ ...portfolio, location: e.target.value })}
//                                     required
//                                 />
//                             </div>

//                             <div className="form-group">
//                                 <div className="detail_banner_wrap">
//                                     <div className="detail_img_grid">

//                                         <div className="upload_item">
//                                             <label>Featured Image</label>
//                                             <input type="file" onChange={handleFeaturedImageChange} ref={featuredImageRef} />
//                                         </div>
//                                         <div className="detail_img_grid">
//                                             {portfolio.featuredImage ? (
//                                                 <div className="detail_img_item">
//                                                     <div className="banner_img_wrap">
//                                                         <img src={`${config.BASE_URL}${portfolio.featuredImage}`} alt="Featured" />
//                                                     </div>
//                                                     <button className="remove_btn" type="button" onClick={() => handleRemoveImage(portfolio.featuredImage)}>Remove</button>
//                                                 </div>
//                                             ) : (
//                                                 <p>No image available.</p>
//                                             )}
//                                         </div>

//                                     </div>

//                                 </div>
//                             </div>

//                             <div className="update_btn_wrap">
//                                 <button className="update_btn" type="submit">Update portfolio</button>
//                             </div>
//                             {successMessage && <p className="success-message">{successMessage}</p>}
//                             {error && <p className="error-message">{error}</p>}
//                         </div>
//                     </form>
//                 ) : (
//                     <h5>Portfolio not found!</h5>
//                 )}
//             </div>
//         </div>
//     );
// }

// export default UpdatePortfolioDetail;













import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import config from '../../config';

function UpdatePortfolioDetail() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [activeLanguage, setActiveLanguage] = useState('en');
    
    // English content (main data)
    const [portfolio, setPortfolio] = useState({
        title: '',
        location: '',
        // slug: ''
    });
    
    // Spanish translation data
    const [spanishData, setSpanishData] = useState({
        language: 'es',
        title: '',
        location: ''
    });
    
    const [featuredImage, setFeaturedImage] = useState(null);
    const [currentFeaturedImage, setCurrentFeaturedImage] = useState('');
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const featuredImageRef = useRef(null);

    useEffect(() => {
        const fetchPortfolioDetails = async () => {
            try {
                const response = await axios.get(`${config.BASE_URL}/api/admin/get-portfolio-admin/${id}`, { 
                    withCredentials: true 
                });
                
                const data = response?.data;
                
                // Set English (main) content
                setPortfolio({
                    title: data.title || '',
                    location: data.location || '',
                    // slug: data.slug || ''
                });
                
                // Set Spanish translation data
                setSpanishData({
                    language: 'es',
                    title: data.spanishData?.title || '',
                    location: data.spanishData?.location || ''
                });
                
                // Set featured image
                setCurrentFeaturedImage(data.featuredImage || '');
                
            } catch (err) {
                setError('Failed to fetch portfolio details');
                console.error('Error fetching portfolio:', err);
            }
        };

        fetchPortfolioDetails();
    }, [id]);

    // Handle language tab switching
    const switchLanguage = (lang) => {
        setActiveLanguage(lang);
    };

    // Handle English form changes
    const handleEnglishChange = (e) => {
        const { name, value } = e.target;
        setPortfolio(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // Handle Spanish form changes
    const handleSpanishChange = (e) => {
        const { name, value } = e.target;
        setSpanishData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleRemoveImage = async (imageName) => {
        try {
            const response = await axios.post(`${config.BASE_URL}/api/admin/remove-image-portfolio`, {
                portfolioId: id,
                imageName
            }, { withCredentials: true });

            if (response.status === 200) {
                setCurrentFeaturedImage('');
                setSuccessMessage('Image removed successfully!');
                setTimeout(() => setSuccessMessage(''), 3000);
            } else {
                console.error('Failed to remove image');
            }
        } catch (err) {
            console.error('Error removing image:', err);
            setError('Failed to remove image');
        }
    };

    const handleFeaturedImageChange = (e) => {
        setFeaturedImage(e.target.files[0]);
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccessMessage('');

        const formData = new FormData();
        
        // English content
        formData.append('title', portfolio.title);
        formData.append('location', portfolio.location);
        // formData.append('slug', portfolio.slug);
        
        // Spanish translation data
        formData.append('spanishData', JSON.stringify(spanishData));

        // Featured image (if new one selected)
        if (featuredImage) {
            formData.append('featuredImage', featuredImage);
        }

        try {
            const response = await axios.put(`${config.BASE_URL}/api/admin/update-portfolio/${id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                withCredentials: true,
            });

            // Update local state with response data
            const updatedData = response.data.portfolio;
            setPortfolio({
                title: updatedData.title,
                location: updatedData.location,
                // slug: updatedData.slug
            });
            
            setSpanishData({
                language: 'es',
                title: updatedData.spanishData?.title || '',
                location: updatedData.spanishData?.location || ''
            });

            if (updatedData.featuredImage) {
                setCurrentFeaturedImage(updatedData.featuredImage);
            }

            // Reset file input
            if (featuredImageRef.current) {
                featuredImageRef.current.value = '';
            }
            setFeaturedImage(null);
            
            setSuccessMessage('Portfolio updated successfully!');
            setTimeout(() => setSuccessMessage(''), 5000);
            
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to update portfolio');
            console.error('Error updating portfolio:', err);
        }
    };

    return (
        <div className="dashboard update_detail_wrap">
            <div className="container">
                <h1 className="dash_title">Edit Portfolio</h1>
                <div className="back_btn_wrap">
                    <button className="back-btn" onClick={() => navigate(-1)}>Go Back</button>
                </div>
                
                {/* Language Tabs */}
                <div className="language-tabs" style={{ marginBottom: '20px' }}>
                    <button 
                        type="button" 
                        className={`tab-btn ${activeLanguage === 'en' ? 'active' : ''}`}
                        onClick={() => switchLanguage('en')}
                        style={{
                            padding: '10px 20px',
                            marginRight: '10px',
                            backgroundColor: activeLanguage === 'en' ? '#007bff' : '#f8f9fa',
                            color: activeLanguage === 'en' ? 'white' : 'black',
                            border: '1px solid #ddd',
                            cursor: 'pointer'
                        }}
                    >
                        English
                    </button>
                    <button 
                        type="button" 
                        className={`tab-btn ${activeLanguage === 'es' ? 'active' : ''}`}
                        onClick={() => switchLanguage('es')}
                        style={{
                            padding: '10px 20px',
                            backgroundColor: activeLanguage === 'es' ? '#007bff' : '#f8f9fa',
                            color: activeLanguage === 'es' ? 'white' : 'black',
                            border: '1px solid #ddd',
                            cursor: 'pointer'
                        }}
                    >
                        Spanish
                    </button>
                </div>

                <form onSubmit={handleFormSubmit} encType="multipart/form-data">
                    <div className="update_details_wrap">
                        
                        {/* English Content */}
                        {activeLanguage === 'en' && (
                            <div className="language-content">
                                <h3>English Content</h3>
                                
                                <div className="form-group">
                                    <label>Title (English)</label>
                                    <input
                                        type="text"
                                        name="title"
                                        value={portfolio.title}
                                        onChange={handleEnglishChange}
                                        required
                                    />
                                </div>

                                {/* <div className="form-group">
                                    <label>Slug (English)</label>
                                    <input
                                        type="text"
                                        name="slug"
                                        value={portfolio.slug}
                                        onChange={handleEnglishChange}
                                        placeholder="url-friendly-slug"
                                        required
                                    />
                                </div> */}

                                <div className="form-group textareaField">
                                    <label>Location (English)</label>
                                    <textarea
                                        name="location"
                                        value={portfolio?.location}
                                        onChange={handleEnglishChange}
                                        rows="4"
                                        placeholder="Enter portfolio location or description"
                                    />
                                </div>
                            </div>
                        )}

                        {/* Spanish Content */}
                        {activeLanguage === 'es' && (
                            <div className="language-content">
                                <h3>Spanish Content</h3>
                                
                                <div className="form-group">
                                    <label>Title (Spanish)</label>
                                    <input
                                        type="text"
                                        name="title"
                                        value={spanishData.title}
                                        onChange={handleSpanishChange}
                                        placeholder="Título en español"
                                    />
                                </div>

                                <div className="form-group textareaField">
                                    <label>Location (Spanish)</label>
                                    <textarea
                                        name="location"
                                        value={spanishData?.location}
                                        onChange={handleSpanishChange}
                                        rows="4"
                                        placeholder="Ingrese la ubicación o descripción del portafolio"
                                    />
                                </div>
                            </div>
                        )}

                        {/* Featured Image Section - Always Visible */}
                        <div className="form-group">
                            <div className="detail_banner_wrap">
                                <div className="detail_img_grid">
                                    <div className="upload_item">
                                        <label>Featured Image</label>
                                        <input 
                                            type="file" 
                                            onChange={handleFeaturedImageChange} 
                                            ref={featuredImageRef}
                                            accept="image/*"
                                        />
                                        <small style={{ color: '#666', fontSize: '12px', display: 'block', marginTop: '5px' }}>
                                            This image will be shared across all language versions
                                        </small>
                                    </div>
                                    
                                    <div className="detail_img_grid">
                                        {currentFeaturedImage ? (
                                            <div className="detail_img_item">
                                                <div className="banner_img_wrap">
                                                    <img 
                                                        src={`${config.BASE_URL}${currentFeaturedImage}`} 
                                                        alt="Featured" 
                                                        style={{ maxWidth: '200px', height: 'auto' }}
                                                    />
                                                </div>
                                                <button 
                                                    className="remove_btn" 
                                                    type="button" 
                                                    onClick={() => handleRemoveImage(currentFeaturedImage)}
                                                >
                                                    Remove
                                                </button>
                                            </div>
                                        ) : (
                                            <p>No image available.</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="update_btn_wrap">
                            <button className="update_btn" type="submit">
                                Update Portfolio
                            </button>
                        </div>
                        
                        {successMessage && (
                            <p className="success-message" style={{ color: 'green', marginTop: '10px' }}>
                                {successMessage}
                            </p>
                        )}
                        {error && (
                            <p className="error-message" style={{ color: 'red', marginTop: '10px' }}>
                                {error}
                            </p>
                        )}
                    </div>
                </form>
            </div>
        </div>
    );
}

export default UpdatePortfolioDetail;